import moment from 'moment';
import { useEffect, useState } from 'react';
import { useRouter } from 'shared-routing';

type UseSpaDaysFilterParams = {
  categoryId: number | null;
  arrivalDate: string | undefined;
  fromDate: string | undefined;
  changeJourneyParam: (dateId: string, date?: string | number) => void;
};

export function useSpaDaysFilter({
  categoryId,
  arrivalDate,
  fromDate,
  changeJourneyParam,
}: UseSpaDaysFilterParams) {
  const router = useRouter();
  const today = moment().format();
  const initialDate = arrivalDate || fromDate || today;

  const [categoryFilterId, setCategoryFilterId] = useState<number | null>(categoryId);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(
    categoryId ? String(categoryId) : null
  );
  const [appliedDate, setAppliedDate] = useState(initialDate);

  useEffect(() => {
    if (arrivalDate) {
      setAppliedDate(arrivalDate);
    }
  }, [arrivalDate]);

  const appliedDateString = appliedDate
    ? moment(appliedDate).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');

  const handleDirectCategoryChange = (value: string) => {
    const numericValue = !value || isNaN(Number(value)) ? null : Number(value);
    setCategoryFilterId(numericValue);
    setSelectedCategory(value || null);
    changeJourneyParam('category', value || undefined);

    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, category: value || undefined },
      },
      undefined,
      { shallow: true }
    );
  };

  return {
    categoryFilterId,
    appliedDateString,
    selectedCategory,
    handleDirectCategoryChange,
  };
}
